export const RACE_COLORS = {
  BLACK:      "#5E4FA2",
  WHITE:      "#9D0142",
  HISPANIC:   "#C0E5A0",
  "ASIAN/PI": "#FE6100",
  "AI/AN":    "#FFB000",
  OTHER:      "#FDC073",
  UNKNOWN:    "#aaaaaa",
};

export const FONT_FAMILY = "Libre Franklin, system-ui, sans-serif";

export const CT_LABELS = {
  all: "All Stops",
  ped: "Pedestrian Stops",
  mv:  "Motor Vehicle Stops",
};

export const CT_OPTIONS = [
  { slug: "all", label: "All" },
  { slug: "ped", label: "Pedestrian" },
  { slug: "mv",  label: "Motor Vehicle" },
];

// On touch devices, disable Plotly interactions so touches scroll the chart container
export const IS_TOUCH = typeof window !== "undefined"
  && window.matchMedia("(hover: none) and (pointer: coarse)").matches;

export const BAR_HEIGHT          = 30;
export const BAR_PADDING         = 170;  // bar chart: t:90 + b:60 + title space
export const BAR_PADDING_DISPARITY = 240; // disparity: t:90 + b:130 + title space (70px more than bar)
export const BAR_PADDING_SM      = 130;
export const BAR_PADDING_AGE     = 240;
